/*@ngInject*/
const ModificationsRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadChangeSet = function (changeSetId) {
        var url = '/rest/ChangeSet/' + changeSetId;

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('modificationsRepository', ModificationsRepository);
